module.exports = __webpack_public_path__ + "img/ic_plant_time.e5aaf1d2.png";